import React, { useEffect, useState } from 'react';
import './index.scss';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames';
import {
  FEE_NAV,
  IPortalNavItem,
  PORTAL_NAV_LIST,
  AUDIT_HUB_NAV,
} from '../../../model/studio/portal-nav';
import { SvgIcon } from '../../../components/svg-icon';
// import { SvgIconName } from '../../../components/svg-icon/model';
import SwitchIcon from '../../../assets/svg/switch-icon.svg';
import SwitchIconHover from '../../../assets/svg/switch-icon-hover.svg';
import StudioSelectIcon from '../../../assets/svg/studio-select-icon.svg';
import { IRootState } from '../../../store/reducers';
import {
  getStudioList,
  StudioAction,
  ISelectStudioAction,
  ReduxStudioActionType,
} from '../../../store/modules/studio';
import { GamesAction } from '../../../store/modules/games';
import { IAPIGameItem, IAuditItem } from '../../../model/api-modules';
import { CreateStudioModal } from '../create-studio';
import { ApplyToJoinModal } from '../apply-studio';
import getFormatMessage from '../../../locales/get-format-message';
import {
  fetchUserPermission,
  PermissionAction,
} from '../../../store/modules/permission';
import { auditReadLog } from '../../lib/aduit-log';
import { isSupportUser } from '../../lib';

export const PortalSidebarNav = () => {
  const history = useHistory();
  const [showCreateStudioModal, setShowCreateStudioModal] =
    useState<boolean>(false);
  const [showApplyJoinModal, setShowApplyJoinModal] = useState<boolean>(false);
  const currentURL = window.location.href;
  const urlParts = new URL(currentURL);
  const pathSegments = urlParts.pathname.split('/');
  const studioIndex = pathSegments.indexOf('studio');
  const studioID = pathSegments[studioIndex + 1];
  const studioList = useSelector(
    (state: IRootState) => state.studio.studioList
  );

  const selectStudio = studioList.find((item) => item.studioID === studioID);
  const selectStudioDispatch = useDispatch<Dispatch<ISelectStudioAction>>();
  // const games = useSelector((state: IRootState) => state.games.games);
  const gameStudioDispatch =
    useDispatch<Dispatch<StudioAction | GamesAction>>();
  const permissionDispatch = useDispatch<Dispatch<PermissionAction>>();
  const isBillingSelected =
    location.pathname.includes('fee') || location.pathname.includes('audithub');
  useEffect(() => {
    initialization();
  }, []);

  const initialization = async () => {
    const res = await getStudioList(gameStudioDispatch)();
    if (res) {
      const currentItem = res.studioList.find(
        (item) => item.studioID === studioID
      );
      if (!currentItem) {
        history.push({ pathname: '/studio/select-studio' });
        return;
      }
      selectStudioDispatch({
        type: ReduxStudioActionType.SELECT_STUDIO,
        result: currentItem,
      });
      fetchUserPermission(permissionDispatch)();
    }
  };

  // const onToSelectStudio = () => {
  //   history.push({ pathname: '/studio/select-studio' });
  // };

  const onClickNav = (item: IPortalNavItem) => {
    if (item.name === getFormatMessage('setting_name')) {
      auditReadLog(IAuditItem.ViewSetting);
    }
    history.push({ pathname: item.pathname });
  };

  const renderNavItem = (item: IPortalNavItem, index: number) => {
    const className = classNames('item nav-item', {
      selected:
        location.pathname.startsWith(item.pathname) ||
        (item.pathname.includes('/fee/') &&
          location.pathname.includes('/fee/')),
    });
    return (
      <div className={className} key={index} onClick={() => onClickNav(item)}>
        <SvgIcon icon={item.icon} className="icon nav-icon" />
        <SvgIcon icon={item.iconHover} className="icon-hover none nav-icon" />
        <span className="nav-text">{item.name}</span>
      </div>
    );
  };

  const formatStudioIDByPathname = () => {
    const { pathname } = location;
    if (pathname.startsWith('/studio')) {
      return pathname.split('/')[2];
    }
    return null;
  };

  const renderNav = () => {
    const studioID = formatStudioIDByPathname();
    const navList = [...PORTAL_NAV_LIST];

    navList.push(FEE_NAV);
    navList.push(AUDIT_HUB_NAV);

    if (studioID) {
      return (
        <div className={`menu ${isBillingSelected ? 'collapsed' : ''}`}>
          <div className="menu-sidebar">
            <div className="sidebar-body">
              {navList.map((item, index) => {
                const updatedPathname = item.pathname.replace(
                  ':studioId',
                  studioID
                );
                return renderNavItem(
                  { ...item, pathname: updatedPathname },
                  index
                );
              })}
            </div>
          </div>
        </div>
      );
    }
    return null;
  };
  // const renderFooter = () => {
  //   return (
  //     <div className="back-icon" onClick={onToSelectStudio}>
  //       <SvgIcon icon={SvgIconName.BackIcon} className="m-r" />
  //       <SvgIcon icon={SvgIconName.BackIconBlueHover} className="m-r none" />
  //       <span className="collapsed-text">Back to Select Studio</span>
  //     </div>
  //   );
  // };

  const onToStudio = async (studio: IAPIGameItem) => {
    selectStudioDispatch({
      type: ReduxStudioActionType.SELECT_STUDIO,
      result: studio,
    });
    fetchUserPermission(permissionDispatch)();

    history.push({ pathname: `/studio/${studio.studioID}/portal` });
    return;
  };

  const showStudioMenu = () => {
    const menu = document.querySelector('.select-studio-box') as HTMLElement;
    menu.style.display = 'block';
  };

  const hideStudioMenu = () => {
    const menu = document.querySelector('.select-studio-box') as HTMLElement;
    menu.style.display = 'none';
  };

  const renderAddStudioModal = () => {
    if (showCreateStudioModal) {
      return (
        <CreateStudioModal
          onToStudio={onToStudio}
          onReload={initialization}
          onClose={() => setShowCreateStudioModal(false)}
        />
      );
    }
  };

  const renderApplyJoinStudioModal = () => {
    if (showApplyJoinModal) {
      return <ApplyToJoinModal onClose={() => setShowApplyJoinModal(false)} />;
    }
  };

  return (
    <div
      className={`portal-nav-box ${
        isBillingSelected ? 'portal-collapsed' : ''
      }`}
    >
      <div className="switch-studio">
        <span className="studio-name" title={selectStudio?.studioName}>
          {selectStudio?.studioName}
        </span>
        <div
          className="switch-icon-box"
          onMouseOver={showStudioMenu}
          onMouseOut={hideStudioMenu}
        >
          <img src={SwitchIcon} className="switch-icon" />
          <img src={SwitchIconHover} className="switch-icon-hover" />
          <div
            className="select-studio-box"
            onMouseOver={showStudioMenu}
            onMouseOut={hideStudioMenu}
          >
            <div className="studio-box">
              {studioList?.length > 0 &&
                studioList.map((item, index) => {
                  return (
                    <div
                      className={classNames(
                        'studio-item',
                        selectStudio?.studioID === item.studioID
                          ? 'select-studio'
                          : ''
                      )}
                      onClick={() => onToStudio(item)}
                      key={index}
                    >
                      <span
                        className="studio-name-select"
                        title={item.studioName}
                      >
                        {item.studioName}
                      </span>
                      {selectStudio?.studioID === item.studioID && (
                        <img
                          src={StudioSelectIcon}
                          className="studio-select-img"
                        />
                      )}
                    </div>
                  );
                })}
            </div>
            {!isSupportUser() && (
              <>
                <div className="studio-btn">
                  <span
                    className="studio-btn-click"
                    onClick={() => setShowCreateStudioModal(true)}
                  >
                    {getFormatMessage('new_studio_button')}
                  </span>
                </div>
                <div className="studio-btn">
                  <span
                    className="studio-btn-click"
                    onClick={() => setShowApplyJoinModal(true)}
                  >
                    {getFormatMessage('apply_to_join')}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="nav-Wrapper">
        <div className="nav-Wrapper-content">{renderNav()}</div>
      </div>
      {renderAddStudioModal()}
      {renderApplyJoinStudioModal()}
      {/* {renderFooter()} */}
    </div>
  );
};
